const classnames = (
  className: string,
  extensions: { [key: string]: boolean }
): string => {
  return (
    className +
    ' ' +
    Object.keys(extensions).reduce((acc, v) => {
      if (extensions[v]) {
        return acc + ' ' + v;
      }
      return acc;
    }, '')
  );
};

const emailPattern =
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export { classnames, emailPattern };
